<template>
  <div>
    <v-overlay v-model="loading">
      <v-progress-circular
        :size="100"
        :width="7"
        color="#4B2A66"
        indeterminate
      />
    </v-overlay>
    <div v-if="$vuetify.breakpoint.smAndDown">
      <v-navigation-drawer v-model="pagemenu" fixed>
        <ShopInfo :shop="shop" class="pa-2" />
      </v-navigation-drawer>
    </div>
    <v-sheet class="py-4">
      <div class="d-flex justify-center mb-2" v-if="$vuetify.breakpoint.smAndDown">
        <v-avatar class="mr-2">
          <img :src="shop.photograph" />
        </v-avatar>
        <v-btn
          class="white"
          dark
          icon
          large
          color="#4B2A66"
          @click.stop="pagemenu = !pagemenu"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>
      <div class="d-flex">
        <v-card class="ml-3" v-if="$vuetify.breakpoint.mdAndUp">
          <ShopInfo :shop="shop" class="ma-4" />
        </v-card>
        <div class="pa-5 flex-grow-1">
          <v-text-field
            v-model="productsQuery"
            @keyup.enter="search(productsQuery)"
            label="Buscar na Loja"
            block
            solo
            outlined
          >
            <template #append>
              <v-btn
                icon
                class="ma-0 pa-0"
                @click="search(productsQuery)"
                @change="search(productsQuery)"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <div v-show="visible" class="mx-auto mt-n4">
            <v-card class="elevation-5" height="auto">
              <v-row>
                <v-col cols="auto" class="ml-5">
                  <v-card-title> Nenhum resultado encontrado! </v-card-title>
                </v-col>
              </v-row>
              <v-divider />
            </v-card>
          </div>
          <div class="mx-auto mt-n4">
            <v-row v-if="products.length > 0" no-gutters>
              <v-col
                v-for="product in products"
                :key="product.title"
                @click="openProduct(product.url_product)"
                cols="12"
                class="pa-2"
              >
                <v-card>
                  <div
                    style="
                      height: 250px;
                    "
                    :style="{
                      'background': `url(${product.images[0]}) no-repeat center top`
                    }"
                    width="500px"
                    height="200px"
                    contain
                  />
                  <v-card-title class="ma-0 pa-0 pl-2">
                    {{ product.product }}
                  </v-card-title>
                  <v-card-actions class="ma-0 pa-0">
                    <v-card-title class="text-button ma-1 pa-0">
                      R$ {{ product.value }}
                    </v-card-title>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <p
              v-if="products.length == 0 && this.visible == false"
              class="text-center white--text font-weight-medium"
            >
              <v-divider class="grey lighten-2 mb-4" />
              Nenhum produto cadastrado até o momento!
            </p>
          </div>
        </div>
      </div>
      <v-btn
        v-if="$store.state.logged"
        width="80"
        height="80"
        color="#4B2A66"
        bottom
        right
        fab
        dark
        fixed
        @click.stop="dialog = true"
      >
        <v-icon large>mdi-comment-processing-outline</v-icon>
      </v-btn>

      <v-dialog v-model="dialog" max-width="500">
        <v-card class="pa-2">
          <v-card-text class="pa-0">
          <v-card-title class="black--text">
            Enviar Mensagem para {{ name_shop }}
          </v-card-title>

            <v-col>
              <v-textarea v-model="message" label="Mensagem" outlined></v-textarea>
            </v-col>

          <v-card-actions>
            <v-spacer />

            <v-btn color="#4B2A66" outlined @click="cancel()"> Cancelar </v-btn>

            <v-btn color="#4B2A66" dark :loading="loading" @click="sendMessage()">
              Enviar
            </v-btn>
          </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-sheet>
    <v-snackbar
      v-show="snackbar"
      multi-line
      color="blue"
      rounded="pill"
      :value="true"
      ><template v-slot:action="{ attrs }">
        <v-btn color="pink" icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import ShopInfo from "@/components/ShopInfo.vue";
export default {
  components: {
    ShopInfo,
  },
  data: () => ({
    snackbar: false,
    text: `Mensagem enviada com sucesso`,
    visible: false,
    productsQuery: "",
    loading: false,
    shop: {},
    right: null,
    pagemenu: false,
    mini: false,
    hidden: false,
    dialog: false,
    dialog1: true,
    message: "",
    name_shop: "",
    id_shop: "",
    id_city: "",
    city: [],
    state: "",
    products: {
      _id: "",
      product: "",
      url_product: "",
      shop_id: "",
      shop: "",
      description: "",
      category: "",
      value: "",
      promotional_value: "",
      hidden: "",
      viewed_products: "",
      images: [],
      image_files: [],
    },
  }),
  methods: {
    sendMessage() {
      this.loading = true;
      this.$axios
        .post("/message/" + this.id_shop, { message: this.message })
        .then(() => {
          this.message = "";
          this.dialog = false;
        })
        .finally(() => {
          this.loading = false;
          this.snackbar = true;
        });
    },
    cancel() {
      this.message = "";
      this.dialog = false;
    },
    openProduct(url_product) {
      this.$router.replace({
        path: this.url + "/" + url_product,
      });
    },
    search(search) {
      if (search.length > 0) {
        this.$axios
          .get("/search_products/" + search + "/" + this.id_shop)
          .then((response) => {
            if (response.data.length != 0) {
              this.visible = false;
              this.products = response.data;
            } else {
              this.visible = true;
              this.products = response.data;
            }
          });
      } else {
        this.visible = false;
        this.$axios.get("/products/" + this.id_shop).then((response) => {
          this.products = response.data;
        });
      }
    },
  },
  mounted() {
    this.$axios
      .get("/shop/" + this.$route.params.shop_url)
      .then((response) => {
        this.shop = response.data;
        document.title = `Olhadela - ${this.shop.shop_name}`;
        this.name_shop = response.data.shop_name;
        this.id_shop = response.data.id;
        this.id_city = response.data.city_id;
        this.url = response.data.url;
        this.loading = false;
        this.$axios.get("/products/" + this.id_shop).then((response) => {
          this.products = response.data;
        });
        this.$axios.get("/city/" + this.id_city).then((response) => {
          this.city = response.data;
          this.$axios
            .get("/state/" + response.data.state_id)
            .then((response) => {
              this.state = response.data.uf;
            });
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 404) {
            this.$router.replace({
              path: "/error404",
            });
          }
        }
      });
  },
  watch: {
    productsQuery: function () {
      this.search(this.productsQuery);
    },
  },
};
</script>
